import React from 'react'

export default function CardSdg({title,desc,img,w,h}) {
  return (
    <div className="px-10 bg-white py-7 xl:w-[535px] group hover:border border-primary rounded-xl hover:shadow-lg">
      <img src={img} alt={desc} width={w} height={h} crossOrigin="anonymouse" />
      <h1 className="my-5 text-xl font-bold group-hover:text-secondary">
        {title}
      </h1>
      <div dangerouslySetInnerHTML={{ __html: desc }} />
      {/* <p className="text-2xl font-normal text-nameColor">{desc}</p> */}
    </div>
  );
}
